import { reactive } from 'vue'
import StorageService from '@/services/StorageService'

const key = 'quiz'

/**
 * @type {{ meta: { dirty: boolean}, data: { questions: { question_id: number, correct: boolean }[] } }}
 */
const store = reactive({
  meta: {
    dirty: false
  },
  data: {
    /** @type {{ question_id: number, correct: boolean }[]} */
    questions: []
  }
})

async function persist () {
  store.meta.dirty = true
  await StorageService.set(key, store)
}

function parseLegacyValues (d = {}) {
  d.data?.questions?.forEach(q => {
    q.question_id = Number(q.question_id)
    // true, 1, '1' as true
    q.correct = q.correct === true || q.correct === 1 || q.correct === '1'
  })

  return d
}

const Quiz = {
  key,

  getStore () {
    return store
  },

  setStore (d = {}) {
    Object.assign(store, parseLegacyValues(d))
  },

  getAnsweredQuestions () {
    return store.data.questions
  },

  // data is always dirty since it is not saved to server. we set it to false so that we skip calling sync.
  isDirty() {
    return false
  },

  sync () {
    // nothing to sync
  },

  /**
   *
   * @param {Number} questionId
   * @param {Boolean} correct
   * @returns {Promise<void>}
   */
  async addAnsweredQuestion (questionId, correct) {
    const q = store.data.questions.find(q => q.question_id === questionId)
    const c = correct ? '1' : '0'

    if (q) {
      q.correct = c
    } else {
      store.data.questions.push({
        question_id: questionId,
        correct: c
      })
    }

    await persist()
  },

  async reset (d = {}) {
    const data = Object.assign({ questions: [] }, d)
    this.setStore({ meta: { dirty: false }, data })
    await persist()
  }
}

export default Quiz
